import { Form, FormInstance } from "antd";
import dayjs from "dayjs";
import { backendDateFormat } from "tm-shared/constants";

import { ScheduleRepeatForm } from "@/pages/SV/RouteManagement/components/ScheduleRepeatForm";
import { ScheduleRepeatFormFields } from "@/pages/SV/RouteManagement/components/ScheduleRepeatForm/ScheduleRepeatForm.types";

import { StyledScheduleFormWrapper } from "../Styled";

export const initialScheduleValues = {
    weekly: 1,
    weekStartDate: dayjs().startOf("week").format(backendDateFormat.date),
    days: [],
};

interface AddPointScheduleFormBlockProps {
    form: FormInstance<ScheduleRepeatFormFields>;
}

export const AddPointScheduleFormBlock = ({
    form,
}: AddPointScheduleFormBlockProps) => {
    return (
        <StyledScheduleFormWrapper>
            <Form<ScheduleRepeatFormFields>
                form={form}
                initialValues={initialScheduleValues}
            >
                <ScheduleRepeatForm form={form} />
            </Form>
        </StyledScheduleFormWrapper>
    );
};
